// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.contact[data-v-7af6b1db] {

    margin-top: 3rem;

    font-family: Roboto;

    line-height: 1.35;

    font-size: 1.125rem;

    font-weight: 400
}
@media (min-width: 996px) {
.contact[data-v-7af6b1db] {

        margin-top: 0
}
.header .contact__title[data-v-7af6b1db] {

        display: none
}
}
.header .contact__email[data-v-7af6b1db] {

    margin-top: 1rem
}
@media (min-width: 996px) {
.header .contact__email[data-v-7af6b1db] {

        display: none
}
}
.header .contact__phone[data-v-7af6b1db] {

    margin-top: 0.5rem
}
@media (min-width: 996px) {
.header .contact__phone[data-v-7af6b1db] {

        display: none
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/Contact.vue"],"names":[],"mappings":";AAYA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAIA;;QAAA;AAAA;AAJA;AASA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <div class=\"contact\">\n    <p class=\"contact__title\">¿Te quedan dudas?</p>\n    <p class=\"contact__email\">\n      <a href=\"mailto:hola@trioteca.com\">hola@trioteca.com</a>\n    </p>\n    <p class=\"contact__phone\"><a href=\"tel:+34910054391\">910 054 391</a></p>\n  </div>\n</template>\n\n<style lang=\"postcss\" scoped>\n.contact {\n  @apply mt-md lg:mt-0 style-body;\n\n  &__title {\n    .header & {\n      @apply lg:hidden;\n    }\n  }\n  &__email {\n    .header & {\n      @apply lg:hidden mt-xxxs;\n    }\n  }\n  &__phone {\n    .header & {\n      @apply lg:hidden mt-nano;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
